import { Button } from "@tellescope/design-system";

interface FilterChipProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

export const FilterChip = ({ label, selected, onClick }: FilterChipProps) => (
  <Button
    variant={selected ? "solid" : "outline"}
    size="sm"
    onClick={onClick}
    // Unselected chips render primary as text + border on a light surface — use the readable
    // (darkened-when-pale) shade so a light primary still meets contrast. Selected chips keep the
    // full primary fill from the variant/color props.
    style={
      selected ? undefined : { color: "hsl(var(--primary-readable))", borderColor: "hsl(var(--primary-readable))" }
    }
  >
    {label}
  </Button>
);
